import { ILayerHostProps, LayerHost } from '@fluentui/react';

export interface IPLayerHostProps extends ILayerHostProps {}

export const IPLayerHost = (props: IPLayerHostProps) => {
  return <LayerHost {...props} />;
};
